import { Injectable } from '@angular/core';
import { ActionCell } from '@material-library';
import { BehaviorSubject } from 'rxjs';

export interface RootLayoutConfig {
  appBar?: any;
  isCustomLayout?: boolean;
  pageTitle?: string;
  useBreadcrumbItems?: boolean;
  linkTitle?: string;
  linkSubTitle?: string;
  breadcrumbActions?: ActionCell;
}

@Injectable({
  providedIn: 'root'
})
export class RootLayoutConfigService {
  private dataSource = new BehaviorSubject<RootLayoutConfig>(null);
  public currentData$ = this.dataSource.asObservable();

  private errcodeSource = new BehaviorSubject<number | null>(null);
  public errcode$ = this.errcodeSource.asObservable();
  public linkRootDirectory = '';
  
  updateConfig(data: RootLayoutConfig) {
    this.dataSource.next(data);
  }

  setErrCode(code: number | null) {
    this.errcodeSource.next(code);
  }
  patchConfig(data: RootLayoutConfig) {
    this.dataSource.next({ ...this.dataSource.getValue(), ...data });
  }
}